import { resolvePageGeometry } from './resolvePageGeometry';
import { ReportPageSetup } from '../types';

/** Page width minus both margins - the width the table has to fit into. */
export const resolvePrintableWidthMm = (page: ReportPageSetup): number =>
  resolvePageGeometry(page).printableWidthMm;
